import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=455ad731"
import script from "./ItemGrid.vue?vue&type=script&lang=js"
export * from "./ItemGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports